function shouldShowV2Debuggers() {
  return (
    typeof window !== "undefined" &&
    localStorage.getItem("replo.debug.v2debuggers") === "true"
  );
}

export default shouldShowV2Debuggers;
